var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":""}},[_c('base-section',{staticClass:"text-center",attrs:{"id":"back-to-blog-overview","space":"56"}},[_c('router-link',{staticClass:"d-block",attrs:{"to":{
        name: 'Blog'
      }}},[_vm._v(" << "+_vm._s(_vm.$t('Click here to get back to the blog overview_'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }